import clinicAdmin from 'api/v2/clinicAdmin';
import clinician from 'api/clinician';
import order from 'api/v2/order';
import coreTracking from 'api/v2/tracking/core';
import uiActionsTrackingV2 from 'api/v2/tracking/uiActions';

export default {
  clinician,
  v2: {
    clinicAdmin,
    tracking: {
      ...coreTracking,
      ...uiActionsTrackingV2,
    },
    order,
  },
};
